// template here
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faCircle } from '@fortawesome/pro-regular-svg-icons'
import { faCircle as faSolidCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

interface Step {
  step: number
  icon: IconProp
}

interface IProps {
  checkOnComplete?: boolean
  totalSteps: number
  currentStep: number
  onClickStep?: (e: React.MouseEvent<SVGSVGElement>, index: number) => void
}

export const StepDots = (props: IProps): React.ReactElement => {
  const { checkOnComplete = true, totalSteps, currentStep, onClickStep: handleClick } = props
  const steps: Step[] = []

  for (let i = 1; i <= totalSteps; i++) {
    const icon =
      currentStep >= i
        ? currentStep === i
          ? faSolidCircle
          : checkOnComplete
          ? faCheckCircle
          : faCircle
        : faCircle
    steps.push({ step: i, icon })
  }

  return (
    <div className="step-container mb-4 text-center">
      {steps.map((step: Step, i: number) => (
        <FontAwesomeIcon
          key={['step', step.step].join(':')}
          className="text-success mx-3"
          icon={step.icon}
          style={handleClick ? { cursor: 'pointer' } : undefined}
          onClick={(e) => handleClick?.(e, i)}
        ></FontAwesomeIcon>
      ))}
    </div>
  )
}
